import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgCart = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M5.08 4H3a1 1 0 1 1 0-2h3a1 1 0 0 1 .997.917L7.253 6H21a1 1 0 0 1 .97 1.243l-1.621 6.485A3 3 0 0 1 17.439 16H8.84a3 3 0 0 1-2.99-2.75L5.08 4zm2.34 4l.424 5.083A1 1 0 0 0 8.84 14h8.598a1 1 0 0 0 .97-.757L19.72 8H7.42zM8 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm8 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" }));
};
export default factorySvgIcon(SvgCart);
//# sourceMappingURL=SvgCart.js.map